import { AuthorByline } from "@/components/site/AuthorByline";
import { personRef } from "@/content/author";
import { createFileRoute } from "@tanstack/react-router";
import bookCover from "@/assets/book-cover-2.webp";
import { hreflangLinks } from "@/lib/seo";
import { PageIntro, PageSection, Prose, MoreLink } from "@/components/site/page";

const CANONICAL = "https://akillisurdurulebilirlik.com/kitaplar/iklim-degil-insanlik-krizi";

const retailers = [
  {
    name: "Yeni İnsan Yayınevi",
    url: "https://yeniinsanyayinevi.com/kitaplarimiz/iklim-degil-insanlik-krizi/",
    note: "Yayıncı resmi sitesi",
    primary: true,
  },
  {
    name: "Amazon",
    url: "https://www.amazon.com.tr/%C4%B0klim-De%C4%9Fil-%C4%B0nsanl%C4%B1k-Krizi-%C3%96zta%C5%9Fk%C4%B1n/dp/6256813103",
    note: "amazon.com.tr",
  },
  {
    name: "D&R",
    url: "https://www.dr.com.tr/kitap/iklim-degil-insanlik-krizi/bilim/ekoloji-cevre-bilim/urunno=0002083648001",
    note: "dr.com.tr",
  },
];

const toc: { part: string; chapters: string[] }[] = [
  {
    part: "Giriş",
    chapters: ["Sahi, nedir bu sürdürülebilirlik?"],
  },
  {
    part: "1 — İklim ve Çevre",
    chapters: [
      "İklim krizi üzerine en kısa hikâye",
      "En basit haliyle iklim krizi nedir?",
      "İklim krizi ve sosyal adalet",
      "Su yoksa, yaşam da yok!",
      "Hızlı ve yıkıcı moda!",
      "Bir tıklamayla gezegeni kurtarmak mı?",
      "Plastik yemek eğlenceli mi?",
      "Plogging: Gezegeni kurtaran egzersiz",
      "Ölümcül tehdit: Orman yangınları",
      "Görmediğimiz tehlike: Uzay çöpleri!",
      "Kelebekler neden kuzeye göçüyor?",
      "Küresel kaynama da neyin nesi?",
    ],
  },
  {
    part: "2 — İş Dünyası ve Ekonomi",
    chapters: [
      "Yeni dönemin iş modeli: Sosyal girişimcilik",
      "Döngüsel ekonomi ve oyuncaklar",
      "Fosilden kaçarken nükleere tutulmak!",
      "150 yaşında yeni doğan: Elektrikli otomobil",
      "Dünyayı besleyen dev: Tarım",
      "ESG'nin darbe yiyen itibarı!",
      "Yeşil yalanlar",
      "#HiperDevSüper indirimler çağı",
      "İyi, kötü ve çirkin: Tüketim Ekonomisi!",
    ],
  },
  {
    part: "3 — İnsan",
    chapters: [
      "Sürdürülebilir insanlık",
      "Cinsiyet eşitliğinde 9000 yıllık utanç!",
      "Çevresel endişe ve öfke!",
      "İyi misiniz? Gerçekten?",
      "Sade iyidir!",
      "#SavaşaHayır!",
      "İklim savaşlarında güç kiminle?",
      "İnsanlığın temel sorunu: İkiyüzlülük!",
      "Bugün hayatta kal, peki yarın?",
      "İklim meselesini harlayan ateş: Eylemsizlik!",
    ],
  },
  {
    part: "4 — Teknoloji",
    chapters: [
      "Teknoloji: Şeytan mı melek mi?",
      "İklim endişesi bitti! Artık, Metaverse var!",
      "Yapay zekâ ile insanlığın geleceği!",
      "ChatGPT ile sohbet!",
      "Dijital Rönesans çağı!",
    ],
  },
  {
    part: "5 — Toparlarsak…",
    chapters: [
      "İklim krizi bir iletişim meselesidir!",
      "Her kriz aslında bir fırsattır!",
      "Son Söz. Akılda ne kalsın?",
      "Kaynakça",
    ],
  },
];

const quotes: { text: string; page?: string }[] = [
  {
    text: "Dünya üzerinde bugün tartıştığımız her sorun insan kaynaklı. Dolayısıyla, meselemiz kendimizle, yani insanlıkla!",
  },
];

const press: { outlet: string; title: string; url: string; date?: string }[] = [
  {
    outlet: "Harvard Business Review Türkiye",
    title: "İklim Değil, İnsanlık Krizi | Arda Öztaşkın",
    url: "https://www.youtube.com/watch?v=222vmSGPSgg",
  },
  {
    outlet: "Harvard Business Review Türkiye",
    title:
      "Sürdürülebilirlik İletişimi ile Etki | Sistem Dönüşümü ve Etki Bölüm: 12 — Arda Öztaşkın",
    url: "https://www.youtube.com/watch?v=WARdJ3I-gM0&t=286s",
  },
  {
    outlet: "EKOTÜRK TV",
    title: "Yaşanabilir Dünya | Arda Öztaşkın | Sibel Topaloğlu",
    url: "https://www.youtube.com/watch?v=Xtj_YUUeoBw&t=1s",
    date: "07.01.2024",
  },
  {
    outlet: "Oksijen TV",
    title:
      "Avrupa Yeşil Mutabakat hedeflerini tehdit değil fırsat olarak görmeliyiz",
    url: "https://www.youtube.com/watch?v=Njig47KCuBM&t=1142s",
  },
  {
    outlet: "Marketing Türkiye",
    title: "İklim değil, insanlık krizi",
    url: "https://www.marketingturkiye.com.tr/haberler/iklim-degil-insanlik-krizi/",
  },
  {
    outlet: "TEGV",
    title: "Arda Öztaşkın kitabının telif gelirini TEGV'e bağışladı",
    url: "https://tegv.org/arda-oztaskin-kitabinin-telif-gelirini-tegve-bagisladi",
  },
];

export const Route = createFileRoute("/kitaplar/iklim-degil-insanlik-krizi")({
  head: () => ({
    meta: [
      { title: "İklim Değil, İnsanlık Krizi — Arda Öztaşkın" },
      {
        name: "description",
        content:
          "Arda Öztaşkın'ın kitabı: sürdürülebilirliği insan, gezegen, ekonomi ve teknoloji boyutlarıyla okuyan bir çağrı. İçindekiler ve satın alma linkleri.",
      },
      {
        property: "og:title",
        content: "İklim Değil, İnsanlık Krizi — Arda Öztaşkın",
      },
      {
        property: "og:description",
        content: "İçindekiler, alıntılar, basın ve satın alma linkleri.",
      },
      { property: "og:type", content: "book" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: CANONICAL },
    ],
    links: [
      { rel: "canonical", href: CANONICAL },
      ...hreflangLinks("/kitaplar/iklim-degil-insanlik-krizi"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Book",
          name: "İklim Değil, İnsanlık Krizi",
          inLanguage: "tr",
          author: personRef(),
          image: `https://akillisurdurulebilirlik.com${bookCover}`,
          url: CANONICAL,
          datePublished: "2023",
          publisher: { "@type": "Organization", name: "Yeni İnsan Yayınevi" },
          workExample: {
            "@type": "Book",
            bookFormat: "https://schema.org/Paperback",
            inLanguage: "tr",
            publisher: { "@type": "Organization", name: "Yeni İnsan Yayınevi" },
            potentialAction: {
              "@type": "ReadAction",
              target: retailers.map((r) => r.url),
            },
          },
          offers: retailers.map((r) => ({
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            priceCurrency: "TRY",
            url: r.url,
            seller: { "@type": "Organization", name: r.name },
          })),
        }),
      },
    ],
  }),
  component: BookPage,
});

function Cover() {
  return (
    <img
      src={bookCover}
      alt="İklim Değil, İnsanlık Krizi — Arda Öztaşkın kitap kapağı"
      width={400}
      height={600}
      loading="lazy"
      decoding="async"
      className="aspect-[2/3] w-full max-w-[200px] object-cover shadow-sm lg:max-w-[280px]"
    />
  );
}

function BookPage() {
  return (
    <div>
      <PageIntro
        crumbs={[{ label: "Kitaplar", to: "/kitaplar" }, { label: "İklim Değil, İnsanlık Krizi" }]}
        kicker="Kitap"
        dot="bg-theme-planet"
        title={<>İklim Değil, <em className="italic">İnsanlık Krizi</em></>}
        lede="Yekta Kopan ve Prof. Dr. Selçuk Şirin'in sunuşuyla. Dünya üzerinde bugün tartıştığımız her sorun insan kaynaklı. Dolayısıyla, meselemiz kendimizle, yani insanlıkla!"
        aside={<Cover />}
      >
        <AuthorByline />
        <div className="mt-5 lg:hidden"><Cover /></div>
      </PageIntro>

      <PageSection title="Kitap hakkında">
        <Prose>
          <p>
            Farkında mısınız? Modern insanlık belki de bu düzeyde bir küresel belirsizlikle ve krizle
            daha önce hiç karşılaşmadı.
          </p>
          <p>
            İklim ve çevre krizi, gelişen ve değiştiren teknolojiler, ekonomik ve sosyal kırılmalar.
            Üstüne, dünyanın farklı coğrafyalarında bırakın çözülmeyi daha da derinleşen temel insan
            hakları, toplumsal cinsiyet eşitliği, eğitim gibi sorunlar...
          </p>
          <p>
            Dünya üzerinde bugün tartıştığımız her sorun insan kaynaklı. Dolayısıyla, meselemiz
            kendimizle, yani insanlıkla! İklim değişikliği de doğanın yarattığı bir kriz değil,
            tersine insanın yarattığı ve sonuçlarını hâlâ gerektiği gibi ciddiye almadığı bir mesele.
          </p>
          <p>
            Arda Öztaşkın, günümüzün bu karmaşık sürdürülebilirlik meselelerini insan, gezegen, ekonomi
            ve teknoloji boyutlarıyla sade, şeffaf ve çarpıcı bir şekilde ortaya koyuyor. Yazar, bireysel
            sorumlulukların önemine işaret ederek, atılacak küçük adımlar ve alınacak basit önlemlerin
            dönüşümün anahtarı olduğunun altını kalınca çiziyor.
          </p>
        </Prose>
      </PageSection>

      <PageSection title="İçindekiler">
        <div className="grid gap-7 sm:grid-cols-2">
          {toc.map((part) => (
            <div key={part.part} className="space-y-2">
              <h3 className="font-serif text-base text-ink/85">{part.part}</h3>
              <ul className="list-decimal space-y-1 pl-5 text-sm leading-relaxed text-ink/75 marker:text-ink/30">
                {part.chapters.map((c) => <li key={c}>{c}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </PageSection>

      <PageSection title="Alıntılar">
        <div className="space-y-6">
          {quotes.map((q, i) => (
            <blockquote key={i} className="border-l-2 border-theme-planet pl-5 font-serif text-lg italic leading-relaxed text-ink/85">
              "{q.text}"
              {q.page && <footer className="mt-2 text-xs not-italic text-ink/60">— {q.page}</footer>}
            </blockquote>
          ))}
        </div>
      </PageSection>

      <PageSection title="Basında">
        <ul className="space-y-4">
          {press.map((p) => (
            <li key={p.url}>
              <MoreLink href={p.url}>{p.title}</MoreLink>
              <p className="mt-1 text-xs text-ink/60">{p.outlet}{p.date ? ` · ${p.date}` : ""}</p>
            </li>
          ))}
        </ul>
      </PageSection>

      <PageSection title="Satın al">
        <div className="flex flex-wrap gap-3">
          {retailers.map((r) => (
            <a
              key={r.name}
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex min-h-11 items-center gap-2 rounded-full border px-4 text-sm ${r.primary ? "border-ink bg-ink text-paper" : "border-ink/20 text-ink/80 hover:border-ink"}`}
            >
              {r.name} <span className="text-xs opacity-70">{r.note}</span>
            </a>
          ))}
        </div>
      </PageSection>

      <PageSection>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-serif text-lg">İngilizce versiyonu için</p>
          <a
            href="https://www.amazon.com/dp/B0H598BYTV/?_encoding=UTF8&pd_rd_w=cpcDQ&content-id=amzn1.sym.3a079c4e-f938-40c9-a0ed-01ef0e9528e9&pf_rd_p=3a079c4e-f938-40c9-a0ed-01ef0e9528e9&pf_rd_r=136-7611256-5080460&pd_rd_wg=pd02H&pd_rd_r=fdf33a34-1c5e-44c1-8dad-c7d32ccc272e"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-11 items-center justify-center rounded-full border border-ink/20 px-5 text-sm hover:border-ink transition-colors"
          >
            Amazon'da görüntüle
          </a>
        </div>
      </PageSection>

      <PageSection>
        <p className="text-sm text-ink/70">Yayıncı</p>
        <p className="mt-1 font-serif text-lg">Yeni İnsan Yayınevi</p>
        <div className="mt-3"><MoreLink to="/">Ana sayfaya dön</MoreLink></div>
      </PageSection>
    </div>
  );
}
